﻿import { CreateSoapState, PatientRecordsSearchFilterFields, ColumnOptions, GridConfiguration, PatientRecordsSearchGridData } from './create-soap.model';

export const SEARCH_CREATE_SOAP_RECORDS = 'SEARCH_CREATE_SOAP_RECORDS'; 
export const GET_CREATE_SOAP_RECORDS = 'GET_CREATE_SOAP_RECORDS';
export const RESET_CREATE_SOAP_GRID_DATA = 'RESET_CREATE_SOAP_GRID_DATA';
export const RESET_CREATE_SOAP_RECORDS_TO_INITIAL_STATE = 'RESET_CREATE_SOAP_RECORDS_TO_INITIAL_STATE';

export const emptyString: string = "";
const patientRecordsSearchFilterFields: PatientRecordsSearchFilterFields = {
    lastName: emptyString,
    firstName: emptyString,
    dob: emptyString,
    prefix: emptyString,
    suffix: emptyString,
    streetAddress: emptyString,
    city: emptyString,
    county: emptyString,
    religion: emptyString,
    zipCode: emptyString,
    country: emptyString,
    email: emptyString,
    race: emptyString,
    occupation: emptyString,
    eyeColor: emptyString,
    hairColor: emptyString,
    physicalMarks: emptyString,
    height: emptyString,
    weight: emptyString,
    birthPlace: emptyString,
    sex: 'N/A',
    maritalStatus: emptyString,
    bloodType: emptyString,
    languagesSpoken: emptyString,
    driverLincense: emptyString,
    ssn: emptyString
};

const columnOptions: ColumnOptions[] = [
    { header: 'Last Name', field: 'Last_Name', sortable: true },
    { header: 'First Name', field: 'First_Name', sortable: true },
    { header: 'Date of Birth', field: 'DOB', sortable: true }
];

export const gridConfiguration: GridConfiguration = {
    page: 1,
    pageSize: 5,
    sort: "Last_Name",
    order: 1
};
const patientRecordsSearchGridData: PatientRecordsSearchGridData = {
    rows: 5,
    rowsPerPageOptions: [5, 10, 20],
    cols: columnOptions,
    pageLinks: 3,
    configuration: gridConfiguration,
    filterData: [],
    totalRecords: 0
};

export const initialState: CreateSoapState = {
    patientRecordsSearchFilterFields: patientRecordsSearchFilterFields,
    patientRecordsSearchGridData: patientRecordsSearchGridData
};